import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IGroupApplication } from './interfaces';

export const getGroupApplicationList = (data: IDynamicTableParams) => {
  return instance()
    .post<IGroupApplication[]>('/applicationGroup/list', data)
    .then((response) => response.data);
};

export const getGroupApplicationAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/applicationGroup/availableColumns')
    .then((response) => response.data);
};

export const getGroupApplicationAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/applicationGroup/availableGroupColumns')
    .then((response) => response.data);
};

export const reassignExecutorGroupApplications = (applicationNumbers: string[], userId: string, comment: string) => {
  return instance()
    .post<void>('/applicationGroup/addApplicationsExecutor', { applicationNumbers, userId, comment })
    .then((response) => response.data);
};
